export default __webpack_public_path__ + "static/media/kadra_krzysiu.5240bce9.jpeg";